import axios from "axios";
import { ActiveSessionWithUser, GroupedVCatUserSessionResponse } from "../../types/models/vcatSession";
import { SessionReport } from "../../types/models";


const REACT_APP_API_URL = process.env.REACT_APP_API_URL || "http://127.0.0.1:8000";



export const fetchAllSessions = async (): Promise<GroupedVCatUserSessionResponse[]> => {
    const token = localStorage.getItem("authToken");
    if (!token) {
      throw new Error("Unauthorized: No token found.");
    }
  
    try {
      const response = await axios.get(
        `${REACT_APP_API_URL}/session/all-sessions`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching all sessions:", error);
      throw new Error("Failed to fetch sessions.");
    }
  };
  
  export const endSessionById = async (sessionId: number): Promise<void> => {
    const token = localStorage.getItem("authToken");
  
    await axios.post(
      `${REACT_APP_API_URL}/session/admin-end`,
      { session_id: sessionId },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
  };
  
  export const getAllActiveSessions = async (): Promise<ActiveSessionWithUser[]> => {
    const token = localStorage.getItem("authToken");
  
    const response = await axios.get(`${REACT_APP_API_URL}/session/all-active`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  
    return response.data;
  };
  


  export const fetchSessionReport = async (
  accountRootId: number,
  billingMonth: string    // e.g. "2025-04"
): Promise<SessionReport[]> => {
  const token = localStorage.getItem("authToken");
  if (!token) {
    throw new Error("Unauthorized: No token found.");
  }

  try {
    const response = await axios.get<SessionReport[]>(
      `${REACT_APP_API_URL}/session/${accountRootId}/${billingMonth}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (err) {
    console.error("Error fetching session report:", err);
    if (axios.isAxiosError(err)) {
      throw new Error(err.response?.data?.detail || "Failed to fetch session report.");
    }
    throw new Error("An unexpected error occurred.");
  }
};